import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { HandbookService } from '../eyedes/audit/services/handbook.service'

export interface Type {
    name: string
    title: string
    component?
    hidden?: boolean
    allowImport?: boolean
    allowExport?: boolean
}

@Injectable()
export class GalvmanHandbookTypesResolver {
    constructor(private handbookService: HandbookService) {
        //
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Type[]> {
        return this.handbookService.getTypes().pipe(
            map(response => {
                const types = response.filter(
                    type => !type.hidden && ['galvanicTreatmentColor', 'saltSupplier'].includes(type.name)
                )

                types.forEach(t => (t.allowImport = true))

                return types
            })
        )
    }
}
